export const routes = {
  AUTH: {
    LOG_IN: '/login',
    RESET_PASSWORD: '/reset-password',
    CHANGE_PASSWORD: '/change-password',
    SIGN_UP: '/sign-up',
  },
  MAIN: {
    INIT: '/dashboard',
    USERS: '/users',
    DOCTORS: '/doctors',
    USER: '/user',
    DOCTOR: '/doctor',
    FINANCES: '/finances',
    ARTICLES: '/articles',
    AWARENESS: '/awareness',
    COMMISSION: '/commission',
    NOTIFICATION: '/notification',
    DASHBOARD: '/dashboard',
    ADMINS: '/admins',
    CONTENT: '/content',
    ONBOARDING_VIDEOS: '/onboarding-videos',
    SMS_DELIVERY: '/sms-delivery',
    SMS_CODES: '/sms-codes',
    ACCOUNT_DELETIONS: '/account-deletions',
  },
} as const;
